import React from 'react';

import AddDocuments from './AddDocuments';
import useAddDocuments from './useAddDocuments';

export interface IAddDocumentsPageProps {}

const AddDocumentsPage = (props: IAddDocumentsPageProps) => {
  const state = useAddDocuments(props);

  return <AddDocuments {...props} {...state} />;
};

export default AddDocumentsPage;
